import React from "react";

type ReorderToggleProps = {
  disabled: boolean;
  pressed: boolean;
  onToggle: React.MouseEventHandler<HTMLButtonElement> | undefined;
};

const ReorderToggle = ({ disabled, pressed, onToggle }: ReorderToggleProps) => (
  <button
    type="button"
    aria-label="Auto Reorder"
    aria-describedby="auto-reorder-description"
    aria-pressed={pressed}
    disabled={disabled}
    onClick={onToggle}
    data-testid="autoReorderToggle"
    className={`cursor-pointer flex flex-row items-center top h-5 w-10 rounded-full m-0 p-0 border-none ${
      pressed
        ? "bg-[#FBD38D] shadow-[0_0_0_1px_inset_#C05621]"
        : "bg-gray-50 shadow-[0_0_0_1px_inset_#454c40]"
    }`}
  >
    <svg
      className="absolute z-0 left-1.5"
      width="10"
      height="7"
      viewBox="0 0 10 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.05468 5.14826L8.65068 0.551758L9.35818 1.25876L4.05468 6.56226L0.872681 3.38026L1.57968 2.67326L4.05468 5.14826Z"
        fill="#9C4221"
      />
    </svg>
    <div
      className={`absolute box-border z-10 h-5 w-5 border border-solid rounded-full bg-white transition-all ${
        pressed ? "ml-5 border-[#C05621]" : "ml-0 border-gray-700"
      }`}
    />
    <svg
      className="absolute z-0 right-4"
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.05468 3.29336L6.52968 0.818359L7.23668 1.52536L4.76168 4.00036L7.23668 6.47536L6.52968 7.18236L4.05468 4.70736L1.57968 7.18236L0.872681 6.47536L3.34768 4.00036L0.872681 1.52536L1.57968 0.818359L4.05468 3.29336Z"
        fill="#3b4238"
      />
    </svg>
  </button>
);

export default ReorderToggle;
